import React from 'react';
export function Footer() {
  return <footer className="bg-black py-10 px-4 text-center border-t border-white/5" data-id="element-150">
      <div className="container mx-auto" data-id="element-151">
        <p className="text-[#d4a017]/60 text-xs tracking-[0.3em] uppercase mb-3" style={{
        fontFamily: "'Cormorant Garamond', serif"
      }} data-id="element-152">
          Formación Integral
        </p>
        <h3 className="text-xl font-serif font-bold text-white mb-5" data-id="element-153">
          Reiki · Sana · Transforma
        </h3>
        <div className="flex justify-center gap-6 mb-6 text-sm text-[#d4a017]/50" data-id="element-154">
          <a href="#" className="hover:text-[#d4a017] transition-colors" data-id="element-155">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-[#d4a017] transition-colors" data-id="element-156">
            Política de Privacidad
          </a>
        </div>
        <p className="text-xs text-[#5c4a2a]/40 max-w-lg mx-auto leading-relaxed" data-id="element-157">
          © 2025 Academia Holística Argentina. Todos los derechos reservados.
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
        </p>
      </div>
    </footer>;
}